export default __webpack_public_path__ + "static/media/triangle.55a565bc.svg";